import React, { useState, useCallback, useEffect } from "react";
import { useHttpClient } from "shared/hooks/http-hook";
import LeadStats from "./LeadStats";
import LeadList from "./LeadList";
import LeadDetail from "./LeadDetail";
import LeadForm from "./LeadForm";

const LeadHunter = () => {
  const { sendRequest } = useHttpClient();
  const [leads, setLeads] = useState([]);
  const [total, setTotal] = useState(0);
  const [stats, setStats] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
    category: "",
    search: "",
    state: "",
    icpTier: "",
    source: "",
    page: 1,
  });

  const fetchLeads = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.status) params.set("status", filters.status);
      if (filters.category) params.set("category", filters.category);
      if (filters.search) params.set("search", filters.search);
      if (filters.state) params.set("state", filters.state);
      if (filters.icpTier) params.set("icpTier", filters.icpTier);
      if (filters.source) params.set("source", filters.source);
      params.set("country", "US");
      params.set("page", filters.page);
      params.set("limit", "50");

      const data = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/admin/lead-hunter/leads?${params.toString()}`,
      );
      setLeads(data.leads || []);
      setTotal(data.total || 0);
    } catch (err) {
      console.error("Failed to fetch leads:", err);
    }
    setLoading(false);
  }, [sendRequest, filters]);

  const fetchStats = useCallback(async () => {
    try {
      const data = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/admin/lead-hunter/stats`);
      setStats(data);
    } catch (err) {
      console.error("Failed to fetch stats:", err);
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchLeads();
    fetchStats();
  }, [fetchLeads, fetchStats]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     fetchStats();
  //   }, 60000);
  //   return () => clearInterval(interval);
  // }, [fetchStats]);

  const handleSelectLead = useCallback((lead) => {
    setSelectedLead(lead);
    setShowForm(false);
  }, []);

  const handleBack = useCallback(() => {
    setSelectedLead(null);
    fetchLeads();
    fetchStats();
  }, [fetchLeads, fetchStats]);

  const handleNewLead = useCallback(() => {
    setShowForm(true);
    setSelectedLead(null);
  }, []);

  const handleLeadCreated = useCallback(() => {
    setShowForm(false);
    fetchLeads();
    fetchStats();
  }, [fetchLeads, fetchStats]);

  const handleRunDiscovery = useCallback(async () => {
    try {
      window.toast.success("Discovery started...");
      await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/admin/lead-hunter/run/discover`, "POST");
      window.toast.success("Discovery completed");
      fetchLeads();
      fetchStats();
    } catch (err) {
      window.toast.error("Discovery failed: " + (err.message || "Unknown error"));
    }
  }, [sendRequest, fetchLeads, fetchStats]);

  if (showForm) {
    return <LeadForm onCancel={() => setShowForm(false)} onCreated={handleLeadCreated} />;
  }

  if (selectedLead) {
    return <LeadDetail leadId={selectedLead._id} onBack={handleBack} />;
  }

  return (
    <div>
      <LeadStats stats={stats} />
      <LeadList
        leads={leads}
        total={total}
        loading={loading}
        filters={filters}
        onFiltersChange={setFilters}
        onSelectLead={handleSelectLead}
        onNewLead={handleNewLead}
        onRunDiscovery={handleRunDiscovery}
      />
    </div>
  );
};

export default LeadHunter;
